// Engine status IDs are not URL-friendly ('Init - 2. Create in manufacturer').
// Slug = the full frozen id, dash-cased. The step number is kept deliberately:
// ids are frozen while display labels can drift, so numbered slugs can't collide.
function slugify(s: string): string {
    return s
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function statusIdToSlug(statusId: string): string {
    return slugify(statusId);
}

// Reverse lookup needs the set of known status IDs (from meta.statuses).
// Returns null when the slug doesn't resolve to any known status.
export function slugToStatusId(slug: string, allStatusIds: readonly string[]): string | null {
    return allStatusIds.find((id) => statusIdToSlug(id) === slug) ?? null;
}
